import pathnames from "routes/pathnames";

import SideNavDto from "dto/components/app-side-nav-dto";

import AppFaqIcon from "components/icons/app-faq-icon";
import AppCareerIcon from "components/icons/app-career-icon";
import AppClientsIcon from "components/icons/app-clients-icon";
import AppEnquiryIcon from "components/icons/app-enquiry-icon";
import AppArticlesIcon from "components/icons/app-articles-icon";
import AppPartnersIcon from "components/icons/app-partners-icon";
import AppPopupAdsIcon from "components/icons/app-popup-ads-icon";
import AppSolutionsIcon from "components/icons/app-solutions-icon";
import AppResourcesIcon from "components/icons/app-resources-icon";
import AppEBrochureIcon from "components/icons/app-e-brochure-icon";
import AppCategoriesIcon from "components/icons/app-categories-icon";
import AppRecipientEmailIcon from "components/icons/app-recipient-email";
import AppSolutionGroupIcon from "components/icons/app-solution-group-icon";
import AppJobApplicationIcon from "components/icons/app-job-application-icon";
import AppOfficeLocationIcon from "components/icons/app-office-location-icon";
import AppArticleCategoryIcon from "components/icons/app-article-category-icon";

const sideNavListing: SideNavDto[] = [
	{
		label: "Services & Solutions",
		path: pathnames.solutions,
		icon: AppSolutionsIcon,
	},
	{
		label: "E-Brochure",
		path: pathnames.eBrochure,
		icon: AppEBrochureIcon,
	},
	{
		label: "Articles",
		path: pathnames.articles,
		icon: AppArticlesIcon,
	},
	{
		label: "Clients",
		path: pathnames.clients,
		icon: AppClientsIcon,
	},
	{
		label: "FAQ",
		path: pathnames.faq,
		icon: AppFaqIcon,
	},
	{
		label: "Resources",
		path: pathnames.resources,
		icon: AppResourcesIcon,
	},
	{
		label: "Enquiry",
		path: pathnames.enquiry,
		icon: AppEnquiryIcon,
	},
	{
		label: "Job Application",
		path: pathnames.jobApplication,
		icon: AppJobApplicationIcon,
	},
	{
		label: "Career",
		path: pathnames.career,
		icon: AppCareerIcon,
	},
	{
		label: "Pop-up Ads",
		path: pathnames.popupAds,
		icon: AppPopupAdsIcon,
	},
	{
		label: "Recipient Email",
		path: pathnames.recipientEmail,
		icon: AppRecipientEmailIcon,
	},
	{
		label: "Partners",
		path: pathnames.partners,
		icon: AppPartnersIcon,
	},
	{
		label: "Solution Group",
		path: pathnames.solutionGroup,
		icon: AppSolutionGroupIcon,
	},
	{
		label: "Solution Categories",
		path: pathnames.solutionCategories,
		icon: AppCategoriesIcon,
	},
	{
		label: "Office Location",
		path: pathnames.officeLocation,
		icon: AppOfficeLocationIcon,
	},
	{
		label: "Articles Categories",
		path: pathnames.articlesCategories,
		icon: AppArticleCategoryIcon,
	},
];

export default sideNavListing;
